import preloader from 'js/app/preloader';

preloader.instrumentAfterPreload();
